/**
 * Class to manage a chromatographic series.
 */
export class ChromatogramSeries {
    name;
    #data;
    #dimension;
    #meta;
    constructor(array, dimension, options = {}) {
        const { meta = {} } = options;
        if (new.target === ChromatogramSeries) {
            throw new Error('You need to create either a 1D or 2D series');
        }
        this.#data = array;
        this.#dimension = dimension;
        this.#meta = meta;
        this.name = '';
    }
    getData() {
        return this.#data;
    }
    is1D() {
        return this.#dimension === 1;
    }
    is2D() {
        return this.#dimension === 2;
    }
    toJSON() {
        return {
            data: this.dataToJson(),
            meta: structuredClone(this.#meta),
        };
    }
    /**
     * Specify an array of index to keep
     * @param array
     */
    keep(array) {
        const newData = [];
        for (const i of array) {
            newData.push(this.#data[i]);
        }
        this.#data = newData;
        return this;
    }
}
//# sourceMappingURL=chromatogram_series.js.map